import { Link } from "wouter";
import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";
import { useT } from "@/i18n";

export default function NotFound() {
  const t = useT();
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1 mx-auto max-w-3xl w-full px-4 md:px-8 py-20 md:py-32 text-center">
        <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-muted-foreground">{t("notFound.code")}</div>
        <h1 className="mt-3 font-serif text-6xl md:text-8xl font-black leading-none tracking-tight">
          {t("notFound.titlePrefix")} <span className="text-[hsl(var(--primary))]">{t("notFound.titleSuffix")}</span>{t("notFound.titleEnd")}
        </h1>
        <p className="mt-5 text-base md:text-lg text-muted-foreground max-w-xl mx-auto">
          {t("notFound.subtitle")}
        </p>
        <div className="mt-8 inline-flex flex-wrap gap-3 justify-center">
          <Link href="/" className="bg-foreground text-background px-5 py-3 font-mono text-xs uppercase tracking-[0.2em] hover:bg-[hsl(var(--primary))] transition-colors">
            {t("notFound.backHome")}
          </Link>
          <Link href="/browse" className="border-2 border-foreground px-5 py-3 font-mono text-xs uppercase tracking-[0.2em] hover:bg-foreground hover:text-background transition-colors">
            {t("notFound.browseArchive")}
          </Link>
        </div>
      </main>
      <Footer />
    </div>
  );
}
